export default "__VITE_ASSET__Blx1Lunq__"